import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { useNavigate } from "react-router-dom";

import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";

import update from "immutability-helper";
import FormControlLabel from "@mui/material/FormControlLabel";

import FormControl from "@mui/material/FormControl";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import InfoIcon from "@mui/icons-material/Info";
import { REFRESH_TOKEN_MUTATION } from "../../graphQL/user_qry";
import { GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY }
from "../../graphQL/component_qry";
import { APPLICANT_ANSWERS_BY_TERM_APPLICANT_ID_QUERY,
         EDIT_TERM_APPLICANT_ANSWER_MUTATE }
from "../../graphQL/term_applicant_answer_qry"
import { EDIT_TERM_APPLICANT_MUTATE }
from "../../graphQL/term_applicant_qry"

import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  RadioGroup,
  Checkbox,
  Tooltip,
  Button,
  IconButton,
  Link,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import SelectQuestionDialog from "./selectQuestionDialog.js";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "185px, -20px, 20px, -180px", //"120px, -20px, 20px, -5px", //-75px, -40px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    min-width: 340px;
    background: #fff;
    color: #000;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.4px;
    display: flex;
    padding: 8px 5px 8px 5px;
    flex-direction: column;
  }
`;

const StyledTooltipCom = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    //textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7.5rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "250px",
    padding: 0,
    color: "#fff",
    height: "40px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "& .MuiDataGrid-scrollbarFiller": {
      //  backgroundColor: "#99D4FF"
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
      display: "flex",
      alignItems: "center",
      minHeight: 50,
    },

    [`& .${gridClasses.cell}.colSpan[data-field='question']`]: {
      justifyContent: "center",
      //  paddingRight: 100,
    },
    [`& .${gridClasses.cell}.totalScore`]: {
      padding: 0,
      height: 56,
      marginBottom: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#99D4FF",
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row": {
      backgroundColor: "#E3F2FD !important",
    },
  },
  textFieldStyle: {
    minwidth: 80,
    width: 80,
    // paddingTop: 15,
    // paddingBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#fff",
      height: 40,
      borderRadius: 10,
      fontSize: 16,
      display: "flex",
      justifyContent: "center",
    },
    "& .MuiOutlinedInput-input": {
      textAlign: "center",
      paddingLeft: 20,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  dataGridFooterStyle: {
    height: 56,
    marginBottom: 0,
    backgroundColor: "#99D4FF",
    display: "flex",
    alignItems: "center",
  },
  dataGridFooterTextStyle: {
    color: "#0D47A1",
    fontSize: 18,
    fontWeight: 700,
    marginLeft: 10,
  },
}));

function ApplicantsDetail({ applicant,
                            applySelectedQues,
                            applyNewTotalAwardedScores,
                            initQuesList }) {
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [applicantDetail, setApplicantDetail] = useState([]); // all applicant detail rows
  const [detailRows, setDetailRows] = useState([]); // will be updated by selecting the questions
  const [openSelQuesDlg, setOpenSelQuesDlg] = useState(false);
  const [quesList, setQuesList] = useState(initQuesList);
  const [errorMsg, setErrorMsg] = useState({noOfSeats: "",});
  const [applicantFormData, setApplicantFormData] = useState([]);
  const [applicantAnswers, setApplicantAnswers] = useState([]);
  const [applicantName, setApplicantName] = useState("");
  const [toBeSavedRecs, setToBeSavedRecs] = useState([]);
  const [totalAssignedScore, setTotalAssignedScore] = useState(0);
  const [totalAwardedScore, setTotalAwardedScore] = useState(0);
  const [saveAlertMsg, setSaveAlertMsg] = useState([]);
  const [detailAlertMsg, setDetailAlertMsg] = useState([]);

  const [fetchFormComponentsAnswers] = useManualQuery(
    GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const [fetchApplicantAnswers] = useManualQuery(
    APPLICANT_ANSWERS_BY_TERM_APPLICANT_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  const [editTermAppAnswer] = useMutation(
    EDIT_TERM_APPLICANT_ANSWER_MUTATE
  );

  const [editTermApp] = useMutation(
    EDIT_TERM_APPLICANT_MUTATE
  );

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  useEffect(() => {
    setApplicantName(
      [applicant.applicantId.userId.firstName +
      " " +
      applicant.applicantId.userId.lastName]
    );
  }, [applicant]);

  // useEffect(() => {
  //
  // }, [initQuesList]);

  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const renderAnswer = (value) => {
      if (value == null) return null;

      const text = Array.isArray(value)
        ? value.join(", ")
        : String(value);
      const urlRegex =
    /(?:https?:\/\/?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;

      const parts = text.split(urlRegex);

      return parts.map((part, index) => {
        const isUrl =
          /^(?:https?:\/\/)?(?:www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?$/i.test(
            part
          );

        if (isUrl) {
          const href = part.startsWith("http")
            ? part
            : `https://${part}`;

          return (
            <a
              key={index}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {part}
            </a>
          );
        }

        return <React.Fragment key={index}>{part}</React.Fragment>;
      });
    };

  const convertTxtToRichTxt = txt => {
    //let contentHTML = draftToHtml(JSON.parse(txt.replace(/'/g, '"')));
    //comment by Sami 30Aug2025
    let contentHTML = draftToHtml(JSON.parse(txt));
    // contentHTML = contentHTML.replace(/<p>/, "");
    contentHTML = contentHTML.replace(
      /<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
      (match, href, text) => {
        // Remove leading protocols
        href = href.replace(/^(https?:\/\/)+/, "");

        // Prepend https://
        href = `https://${href}`;

        return `<a href="${href}" target="_blank">${text}</a>`;
      }
    );
    const convertedTxt = ReactHtmlParser(contentHTML);
    return convertedTxt;
  };

  const shortenAnswer = (fullAns, length) => {
    //trim the string to the maximum length
    var trimmedString = fullAns.substr(0, length);

    //re-trim if we are in the middle of a word
    trimmedString = trimmedString.substr(0,
      Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")))
    return trimmedString
  }

  const saveAwardedScore = async() => {
    // Save changed awarded scores for term applicant answers
    if (toBeSavedRecs.length === 0){
      setSaveAlertMsg({
        title: "Save Score",
        msg: "No change in awarded scores for applicant: '" +
        applicantName + "' to be saved.",
      });
      return
    }
    for (var i = 0; i < toBeSavedRecs.length; i++) {
      if(toBeSavedRecs[i].termApplicantAnswerId &&
        toBeSavedRecs[i].termApplicantId.termApplicantId &&
        toBeSavedRecs[i].answerId.answerId){
        const { data, error } = await editTermAppAnswer({
          variables: {
            termApplicantAnswerId:
              parseInt(toBeSavedRecs[i].termApplicantAnswerId),
            termApplicantId:
              parseInt(toBeSavedRecs[i].termApplicantId.termApplicantId),
            answerId:
              parseInt(toBeSavedRecs[i].answerId.answerId),
            applicantAnswer: toBeSavedRecs[i].applicantAnswer,
            assignedScore:
              parseInt(toBeSavedRecs[i].assignedScore),
            awardedScore:
              parseInt(toBeSavedRecs[i].awardedScore)
          },
        });
        if (error) {
          console.log("Error", error, data);
        } else {
          console.log("Success in editing term applicant answer record",
            data.editTermApplicantAnswer.termApplicantAnswer);
        }
      }
    }

    // Save total awarded score for a term applicant.length > 0
    if (toBeSavedRecs && toBeSavedRecs.length > 0){
      const { data: editTermData,
              error: editTermError } = await editTermApp({
        variables: {
          termApplicantId:
            parseInt(toBeSavedRecs[0].termApplicantId.termApplicantId),
          termId:
            parseInt(toBeSavedRecs[0].termApplicantId.termId.termId),
          totalAssignedScore: parseInt(totalAssignedScore),
          totalAwardedScore: parseInt(totalAwardedScore),
          applicationAccepted:
            toBeSavedRecs[0].termApplicantId.applicationAccepted,
          applicantStatus:
            toBeSavedRecs[0].termApplicantId.applicantStatus,

          applicationStatus:
            toBeSavedRecs[0].termApplicantId.applicationStatus,
        },
      });
      if (editTermError) {
        console.log("Error", editTermError, editTermData);
      } else {
        console.log("Success in editing term applicant record",
          editTermData.editTermApplicant.termApplicant);
        applyNewTotalAwardedScores(
          editTermData.editTermApplicant.termApplicant
        );
      }
    };
    setSaveAlertMsg({
      title: "Save Score",
      msg: "Awarded scores for applicant: '" +
      applicantName + "' is saved.",
    });
  }

  const openDetailDialog = (question, fullAnswer) => {
    setDetailAlertMsg({
      title: "Full Content",
      headerMsg: question,
      msg: fullAnswer,
    });
  }

  const getApplicantAnswers = async () => {
    if (applicant.termApplicantId) {
      // Get Applicant Answers
      const {
        loading: applicantAnswersLoading,
        error: applicantAnswersError,
        data: applicantAnswersData,
      } = await fetchApplicantAnswers({
        variables: {  termApplicantId:
                      parseInt(applicant.termApplicantId) },
      });

      if (
        !applicantAnswersLoading &&
        applicantAnswersData &&
        applicantAnswersData.appAnswersBytermApplicantId
      ) {
        // console.log(
        //   "AppAnswers----",
        //   applicantAnswersData.appAnswersBytermApplicantId
        // );
        setApplicantAnswers(
          applicantAnswersData.appAnswersBytermApplicantId
        );
      };
      if (
        applicantAnswersError &&
        applicantAnswersError.graphQLErrors &&
        applicantAnswersError.graphQLErrors[0].message ===
          "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      };
    };
  }

  const getApplicantData = async () => {
    if (applicant.termId.formId.formUuid &&
      applicantAnswers.length > 0) {

      // Get applicant answres
      const {
        loading: formComponentsAnswersLoading,
        error: formComponentsAnswersError,
        data: formComponentsAnswersData,
      } = await fetchFormComponentsAnswers({
        variables: { formUuid: applicant.termId.formId.formUuid },
      });

      if (
        !formComponentsAnswersLoading &&
        formComponentsAnswersData &&
        formComponentsAnswersData.formComponentAnswerList
      ) {
        // console.log(
        //   "ApplicantFormData----",
        //   formComponentsAnswersData.formComponentAnswerList.componentList
        // );

        let questions =
          formComponentsAnswersData.formComponentAnswerList.componentList;
        let appDetailRows = [];

        for (var i = 0; i < questions.length; i++)
        {
          if (questions[i].answerTypeId.name !== "content")
          {
            let appDetailRow= [];
            appDetailRow["question"] = {
              id: i + 1,
              value: convertTxtToRichTxt(questions[i].label),
              checked: true
            };

            appDetailRow["mandatory"] = questions[i].mandatory;

            let foundAnswer = applicantAnswers.filter(item =>
              item.answerId.componentId.componentId === questions[i].componentId
            )

            if (foundAnswer){
              if (questions[i].answerTypeId.name === "text" ||
                  questions[i].answerTypeId.name === "textarea" ||
                  questions[i].answerTypeId.name === "drop_down" ||
                  questions[i].answerTypeId.name === "drop_down_state" ||
                  questions[i].answerTypeId.name === "drop_down_country" ||
                  questions[i].answerTypeId.name === "checkbox_single"){                  
                appDetailRow["answer"] =
                  foundAnswer.length !== 0
                  ?
                    !questions[i].mandatory &&
                    foundAnswer[0].applicantAnswer === ""
                    ? "Not provided"
                    : foundAnswer[0].applicantAnswer
                  :
                  "Not provided"

                appDetailRow["assignedScore"] =
                  foundAnswer.length !== 0
                  ?
                    !questions[i].mandatory &&
                    foundAnswer[0].applicantAnswer === ""
                    ? [0]
                    : foundAnswer[0].assignedScore
                  : [0]

                appDetailRow["awardedScore"] =
                  foundAnswer.length !== 0
                  ?
                    !questions[i].mandatory &&
                    foundAnswer[0].applicantAnswer === ""
                    ? [0]
                    : foundAnswer[0].awardedScore
                  : [0]
              }
              else if (questions[i].answerTypeId.name === "checkbox_multiple" ||
                questions[i].answerTypeId.name === "radio_button"){

                appDetailRow["answer"] = foundAnswer.map(
                  ({ applicantAnswer }) => applicantAnswer
                );

                if (!questions[i].mandatory &&
                    appDetailRow.answer.length === 0 )
                  appDetailRow.answer = "Not provided";

                appDetailRow["assignedScore"] = foundAnswer.map(
                  ({ assignedScore }) => assignedScore
                );

                if (!questions[i].mandatory &&
                    appDetailRow.answer.length === 0 )
                  appDetailRow.assignedScore = [0];

                appDetailRow["awardedScore"] = foundAnswer.map(
                  ({ awardedScore }) => awardedScore
                );

                if (!questions[i].mandatory &&
                    appDetailRow.answer.length === 0 )
                  appDetailRow.awardedScore = [0];
              };
              appDetailRow["answerId"] = foundAnswer.map(
                ({ answerId }) => answerId.answerId
              );
            };
            appDetailRow["answerList"] =
              questions[i].answerList.map(
                ({ label }) => label
              );
            appDetailRow["scoreList"] =
              questions[i].answerList.map(
                ({ score }) => score
              );
            appDetailRow["type"] = questions[i].answerTypeId.name;

            appDetailRows.push({
              // index: row.index,
              answerId: appDetailRow.answerId,
              answer: appDetailRow.answer,
              mandatory: appDetailRow.mandatory,
              question: appDetailRow.question,
              answerList: appDetailRow.answerList,
              scoreList: appDetailRow.scoreList,
              type: appDetailRow.type,
              assignedScore: appDetailRow.assignedScore,
              awardedScore: appDetailRow.awardedScore,
            });
          };
        }
        setApplicantFormData(appDetailRows);
      };
      if (
        formComponentsAnswersError &&
        formComponentsAnswersError.graphQLErrors &&
        formComponentsAnswersError.graphQLErrors[0].message ===
          "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      };
    };
  };
  

  useEffect(() => {
    (() => getApplicantData())();
  }, [applicant, applicantAnswers]);

  useEffect(() => {
    (() => getApplicantAnswers())();
  }, [applicant]);

  useEffect(() => {
    let rows = [];
    //first row with col span
    rows.push({
      index: 0,
      answerId: "",
      answer: "",
      mandatory: "",
      question: "",
      answerList: [],
      scoreList: [],
      type: "",
      assignedScore: "",
      awardedScore: "",
    });
    //second row with col span for showing total scores
    rows.push({
      index: 1,
      answerId: "",
      answer: "",
      mandatory: "",
      question: "",
      answerList: [],
      scoreList: [],
      type: "",
      assignedScore: "",
      awardedScore: "",
    });
    for (var i = 0; i < applicantFormData.length; i++) {
      let row = [];
      row["index"] = i + 2;
      row["answerId"] = applicantFormData[i].answerId;
      row["answer"] = renderAnswer(applicantFormData[i].answer);
      row["mandatory"] = applicantFormData[i].mandatory;
      row["question"] = applicantFormData[i].question;
      row["type"] = applicantFormData[i].type;
      row["answerList"] = applicantFormData[i].answerList;
      row["scoreList"] = applicantFormData[i].scoreList;
      row["assignedScore"] = applicantFormData[i].assignedScore;
      row["awardedScore"] = applicantFormData[i].awardedScore;
      rows.push({
        index: row.index,
        answerId: row.answerId,
        answer: row.type === "checkbox_single"
                ?
                  row.answer === "true"
                  ? "Checked"
                  : "Unchecked"
                : row.answer,
        mandatory: row.mandatory,
        question: row.question,
        answerList: row.answerList,
        scoreList: row.scoreList,
        type: row.type,
        assignedScore: (Array.isArray(row.assignedScore))
                      ? row.assignedScore
                      : [row.assignedScore],
        awardedScore: (Array.isArray(row.awardedScore))
                      ? row.awardedScore
                      : [row.awardedScore],
      });
    }
    if (quesList.length === 0) {
      // set Question list for first time
      let quesList1 = [];
      applicantFormData.map((item) => {
        item.type !== "content" &&
        quesList1.push(item.question);
      });
      setQuesList(quesList1);
    }
    setApplicantDetail(rows);
    setDetailRows(rows);
  }, [applicantFormData]);

  useEffect(() => {
    let newList = [];
    if (applicantDetail.length === 0) return;
    applicantDetail.map((row, index) => {
      // to show applicant name and total scores
      if (index === 0 || index === 1) newList.push(row);
      const quesIdx = quesList.findIndex(
        (item) => item.id === row.question.id && item.checked
      );
      if (quesIdx !== -1) newList.push(row);
    });
    setDetailRows(newList);
  }, [quesList, applicantDetail]);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  const classes = useStyles();

  const columns = [
    {
      field: "question",
      headerName: "Question",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      colSpan: (value, row) => {
        if (row.index === 0) {
          return 4;
        }
        else if (row.index === 1){
          return 2;
        }
        return undefined;
      },
      renderCell: (rows) => {
        let title = (
          <Box
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid
              container
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                paddingLeft: 10,
              }}
            >
              <Grid item xs={9}>
                <Typography variant="h2">Answer</Typography>
              </Grid>

              <Grid item xs={3} style={{ textAlign: "center" }}>
                <Typography style={{ paddingTop: 3 }} variant="h2">
                  Assigned Score
                </Typography>
              </Grid>
            </Grid>
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type === "checkbox_multiple" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={false}
                        style={{ padding: 5 }}
                      />

                      <Typography variant="h3">{item}</Typography>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "center" }}>
                      <Typography style={{ paddingTop: 3 }} variant="h2">
                        {rows.row.scoreList[index]}
                      </Typography>
                    </Grid>
                  </Grid>
                )
            )}
            {rows.row.answerList.map(
              (item, index) =>
                rows.row.type === "radio_button" && (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Grid
                      item
                      xs={9}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-radio-buttons-group-label"
                          defaultValue="female"
                          name="radio-buttons-group"
                          style={{ paddingLeft: 10 }}
                        >
                          <FormControlLabel
                            value={item}
                            control={
                              <Radio checked={false} style={{ padding: 5 }} />
                            }
                            label={
                              <Typography
                                variant="h3"
                                style={{ color: "black" }}
                              >
                                {item}
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={3} style={{ textAlign: "center" }}>
                      <Typography style={{ paddingTop: 3 }} variant="h2">
                        {rows.row.scoreList[index]}
                      </Typography>
                    </Grid>
                  </Grid>
                )
            )}
          </Box>
        );
        if (rows.row.index === 0) {
          return (
            <>
              <Typography
                style={{ paddingRight: 5, paddingBottom: 2 }}
                variant="h2"
              >
                Applicant:
              </Typography>
              <Typography variant="h3">{applicantName}</Typography>
            </>
          );
        }
        else if (rows.row.index === 1) {
          return (
            <>
              <Grid container className={classes.dataGridFooterStyle}>
                <Typography
                  className={classes.dataGridFooterTextStyle}
                  variant="h2"
                >
                  Total Score
                </Typography>
              </Grid>
            </>
          );
        } else if (
          rows.row.type === "radio_button" ||
          rows.row.type === "checkbox_multiple"
        )
          if (rows.row.mandatory)
            return (
              <Box
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <StyledTooltip title={title}>
                  <Box pr={1} pt={0.5} style={{ textAlign: "left" }}>
                    <InfoIcon
                      height={24}
                      color="action"
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </StyledTooltip>
                <StyledTooltipCom title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltipCom>
                <Typography variant="h2">{rows.row.question.value}</Typography>
              </Box>
            );
          else
            return (
              <Box
                style={{ display: "flex", alignItems: "center", width: "100%" }}
              >
                <StyledTooltip title={title}>
                  <Box pr={1} pt={0.5} style={{ textAlign: "left" }}>
                    <InfoIcon
                      height={24}
                      color="action"
                      style={{ cursor: "pointer" }}
                    />
                  </Box>
                </StyledTooltip>
                <Typography variant="h2">{rows.row.question.value}</Typography>
              </Box>
            );
        else if(rows.row.mandatory)
          return(
            <Box
              pb={0.25}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <StyledTooltipCom title="required field">
                <Typography
                  variant="h3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "#E53935",
                    paddingLeft: 5,
                    paddingRight: 5,
                  }}
                >
                  *
                </Typography>
              </StyledTooltipCom>
              <Typography variant="h2">{rows.row.question.value}</Typography>
            </Box>
          )
        else
          return (
            <Typography variant="h2">{rows.row.question.value}</Typography>
          );
      },
    },
    {
      field: "applicantAnswer",
      headerName: "Applicant Answer",
      headerClassName: "super-app-theme--header",
      width: 400,
      minHeight: 50,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.type === "textarea"){
          if(rows.row.answer.length < 100){
            return <Typography variant="h3">{rows.row.answer}</Typography>
          }
          else
          {
            return (
                <Typography
                  style={{
                    wordBreak: "break-word",
                  }}
                  variant="h3">
                  {shortenAnswer(rows.row.answer, 110) + " ..."}
                  <Link
                    style={{
                      cursor: 'pointer'
                    }}
                    onClick={() => openDetailDialog(
                              rows.row.question.value,
                              rows.row.answer
                            )}
                  >
                    more
                  </Link>
                </Typography>
            )
          }
        }
        else if (
            rows.row.type === "text" ||
            rows.row.type === "drop_down" ||
            rows.row.type === "drop_down_state" ||
            rows.row.type === "drop_down_country") {
          return <Typography variant="h3">{rows.row.answer}</Typography>;
        } else if (rows.row.type === "radio_button") {
          return (
            <Grid
              container
              spacing={1}
              style={{ paddingTop: 10, paddingBottom: 5 }}
            >
              <Grid item xs={12}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    {rows.row.answer !== "Not provided"
                    ?
                    rows.row.answer.map((item, i) => (
                      <FormControlLabel
                        value={item}
                        onClick={(e) => e.preventDefault()}
                        style={{ cursor: "default" }}
                        control={
                          <Radio
                            disableRipple
                            onClick={(e) => e.preventDefault()}
                            style={{ cursor: "default" }}
                            checked={true}
                            tabIndex={"-1"}
                          />
                        }
                        label={
                          <Typography variant="h3" style={{ color: "#1d1f21" }}>
                            {item}
                          </Typography>
                        }
                      />
                    ))
                    :
                    <Typography variant="h3">{rows.row.answer}</Typography>
                  }
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>
          );
        } else if (rows.row.type === "checkbox_multiple") {
          return (
            <Grid container>
              <Grid item xs={12}>
                {rows.row.answer !== "Not provided"
                ?
                rows.row.answer.map((item, i) => (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={true}
                        style={{ color: "#0D47A1", paddingLeft: 0 }}
                        tabIndex={"-1"}
                      />
                      <Typography variant="h3">{item}</Typography>
                    </Box>
                  </Box>
                ))
                :
                <Typography variant="h3">{rows.row.answer}</Typography>
              }
              </Grid>
            </Grid>
          );
        } else if (rows.row.type === "checkbox_single") {
          return (
            <Grid container>
              <Grid item xs={12}>
                {rows.row.answer !== "Not provided"
                ?
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <Checkbox
                        disabled
                        checked={rows.row.answer}
                        style={{ color: "#0D47A1", paddingLeft: 0 }}
                        tabIndex={"-1"}
                      />
                    </Box>
                  </Box>
                :
                <Typography variant="h3">{rows.row.answer}</Typography>
              }
              </Grid>
            </Grid>
          );
        }        
      },
    },
    {
      field: "assignedScore",
      headerName: "Assigned Score",
      headerClassName: "super-app-theme--header",
      minWidth: 100,
      height: 50,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.index === 1) {
          return (
            <>
              <Grid container
                className={classes.dataGridFooterStyle}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  className={classes.dataGridFooterTextStyle}
                  variant="h2"
                >
                  {totalAssignedScore}
                </Typography>
              </Grid>
            </>
          );
        }
        else if (!rows.row.assignedScore ||
            rows.row.assignedScore == "N/A")
          return <div>{rows.row.assignedScore}</div>;
        else {
          return (
            <Box
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.assignedScore &&
               rows.row.assignedScore.map((as, index) => (
                <Box
                  pt={0.5}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    height: 40,
                  }}
                >
                  {as}
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
    {
      field: "awardedScore",
      headerClassName: "super-app-theme--header",
      headerName: "Awarded Score",
      minWidth: 100,
      height: 50,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: (rows) => {
        if (rows.row.index === 1) {
          return (
            <>
              <Grid container
                className={classes.dataGridFooterStyle}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  className={classes.dataGridFooterTextStyle}
                  variant="h2"
                >
                  {totalAwardedScore}
                </Typography>
              </Grid>
            </>
          );
        }
        else if (rows.row.awardedScore == "N/A")
          return <div>{rows.row.awardedScore}</div>;
        else {
          return (
            <Box
              pb={0.5}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {rows.row.awardedScore &&
               rows.row.awardedScore.map((aw, index) => (
                <Box pt={0.5}>
                  <TextField
                    className={classes.textFieldStyle}
                    name="awardedScore"
                    variant="outlined"
                    defaultValue={aw}
                    type="number"
                    InputProps={{
                      inputProps: { min: 0, pattern: "[0-9]*" },
                    }}
                    onKeyPress={(e) => {
                      if (e?.key === "-" || e?.key === "+") {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) =>
                      updateAssignedScore(e.target.value, rows.row.index, index)
                    }
                  />
                </Box>
              ))}
            </Box>
          );
        }
      },
    },
  ];
  const updateAssignedScore = (value, index, scoreIdx) => {
    const foundAppDetailRow = applicantDetail.find(
      (appDetail) => appDetail.index === index
    );
    foundAppDetailRow.awardedScore[scoreIdx] = parseInt(value);
    const foundDetailRow = detailRows.find((row) => row.index === index);
    foundDetailRow.awardedScore[scoreIdx] = parseInt(value);
    const foundAppAnswerRec = applicantAnswers.find(
      (applicantAnswer) =>
      applicantAnswer.answerId.answerId === foundDetailRow.answerId[scoreIdx]
    )
    if (foundAppAnswerRec){
      foundAppAnswerRec.awardedScore = parseInt(value);
      toBeSavedRecs.push(foundAppAnswerRec);
      setToBeSavedRecs(toBeSavedRecs);
    }
    setApplicantDetail(prev =>
        prev.map(row => {
          if (row.index !== index) return row;

          const awardedScore = [...row.awardedScore];
          awardedScore[scoreIdx] = parseInt(value);

          return {
            ...row,
            awardedScore,
          };
        })
      );
  };

  const customFooter = () => {
    let calAssignedScore = 0;
    let calAwardedScore = 0;
    applicantDetail.map((item, index) => {
      if (index < 2) return;
      item.assignedScore && item.assignedScore !== "N/A" &&
        item.assignedScore.map((ass) => {
          if (parseInt(ass)) calAssignedScore += ass;
        });
      item.awardedScore && item.awardedScore !== "N/A" &&
        item.awardedScore.map((aw) => {
          if (parseInt(aw)) calAwardedScore += aw;
        });
    });
    setTotalAssignedScore(calAssignedScore);
    setTotalAwardedScore(calAwardedScore);

    return (
      <Grid container className={classes.dataGridFooterStyle}>
        <Grid item xs={8}>
          <Typography className={classes.dataGridFooterTextStyle}>
            Total Score
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            style={{ paddingLeft: 90 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAssignedScore}
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography
            style={{ paddingLeft: 88 }}
            className={classes.dataGridFooterTextStyle}
          >
            {calAwardedScore}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  if (loadContent && detailRows.length > 2)
    return (
      <>
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              onClick={() => setOpenSelQuesDlg(true)}
            >
              Select Questions
            </Button>
          </Grid>
        </Grid>
        <Box style={{ marginTop: 20 }}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={detailRows}
            showCellRightBorder={true}
            //  hideFooter={true}
            autoWidth={true}
            autoHeight={true}
            getRowId={(row) => row.index}
            getRowClassName={(rows) => {
              if (rows.row.index % 2 === 0) return "even";
              else return "odd";
            }}
            getCellClassName={(rows) => {
              if (rows.row.index === 0) return "colSpan";
              if (rows.row.index === 1) return "totalScore";
            }}
            getRowHeight={() => "auto"}
            //experimentalFeatures={{ newEditingApi: true }}
            hideFooterSelectedRowCount
            slots={{
              footer: customFooter,
            }}
          />
        </Box>
        <Grid
          container
          spacing={1}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: 20,
          }}
        >
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              //  style={{width:170, marginRight:45}}
              onClick={() => {
                saveAwardedScore();
                setToBeSavedRecs([]);
              }}
            >
              Save Awarded Score
            </Button>
          </Grid>
        </Grid>
        {openSelQuesDlg && (
          <SelectQuestionDialog
            quesList={quesList}
            applySelections={(selQuesLst) => {
              setOpenSelQuesDlg(false);
              setQuesList(selQuesLst);
              applySelectedQues(selQuesLst);
            }}
            closeDialog={() => setOpenSelQuesDlg(false)}
          />
        )}
        {saveAlertMsg.msg && (
          <AlertDialog
            title={saveAlertMsg.title}
            type={saveAlertMsg.type}
            contentMsg={saveAlertMsg.msg}
            closeDialog={() => setSaveAlertMsg([])}
          />
        )}
        {detailAlertMsg.msg && (
          <AlertDialog
            title={detailAlertMsg.title}
            type={detailAlertMsg.type}
            contentMsg={detailAlertMsg.msg}
            headerMsg={detailAlertMsg.headerMsg}
            closeDialog={() => setDetailAlertMsg([])}
          />
        )}
      </>
    );
  else return;
}

export default ApplicantsDetail;
